import type { ThemeType } from "../_base"
import baseTheme from "../_base"

const lightTheme: ThemeType = {
    ...baseTheme,
}

export default lightTheme
